/**
 * @generated SignedSource<<23792a2d34e85e29e6117c059ef6bca4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateGoogleCalendarInput = {
  id?: string | null;
  viewPrivateEvents?: boolean | null;
  enabledCalendarIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateGoogleCalendarMutation$variables = {
  input: UpdateGoogleCalendarInput;
};
export type UpdateGoogleCalendarMutation$data = {
  readonly updateGoogleCalendar: {
    readonly googleCalendar: {
      readonly calendarViewPrivateEvents: boolean | null;
      readonly enabledCalendars: ReadonlyArray<string | null> | null;
    } | null;
  } | null;
};
export type UpdateGoogleCalendarMutation$rawResponse = {
  readonly updateGoogleCalendar: {
    readonly googleCalendar: {
      readonly calendarViewPrivateEvents: boolean | null;
      readonly enabledCalendars: ReadonlyArray<string | null> | null;
      readonly id: string;
    } | null;
  } | null;
};
export type UpdateGoogleCalendarMutation = {
  variables: UpdateGoogleCalendarMutation$variables;
  response: UpdateGoogleCalendarMutation$data;
  rawResponse: UpdateGoogleCalendarMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarViewPrivateEvents",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabledCalendars",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateGoogleCalendarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateGoogleCalendarPayload",
        "kind": "LinkedField",
        "name": "updateGoogleCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegration",
            "kind": "LinkedField",
            "name": "googleCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateGoogleCalendarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateGoogleCalendarPayload",
        "kind": "LinkedField",
        "name": "updateGoogleCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegration",
            "kind": "LinkedField",
            "name": "googleCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "586c4a4832d9dd560602faab87900418",
    "id": null,
    "metadata": {},
    "name": "UpdateGoogleCalendarMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateGoogleCalendarMutation(\n  $input: UpdateGoogleCalendarInput!\n) {\n  updateGoogleCalendar(input: $input) {\n    googleCalendar {\n      calendarViewPrivateEvents\n      enabledCalendars\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac5233fa7dcd49d3cfd1096df327b9e1";

export default node;
